import { render, staticRenderFns } from "./PrecoloredDesign.vue?vue&type=template&id=8a01f3ec&scoped=true&"
import script from "./PrecoloredDesign.vue?vue&type=script&lang=js&"
export * from "./PrecoloredDesign.vue?vue&type=script&lang=js&"
import style0 from "./PrecoloredDesign.vue?vue&type=style&index=0&id=8a01f3ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a01f3ec",
  null
  
)

export default component.exports